document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-phantom-section]').forEach((section) => {
    const image = section.querySelector('.phantom-shoe');
    const colorName = section.querySelector('[data-color-name]');
    const swatches = section.querySelectorAll('.phantom-swatch');

    if (!image || !swatches.length) return;

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const newImage = swatch.dataset.imageUrl;
        const newName = swatch.dataset.colorName;

        if (!newImage) return;

        swatches.forEach((item) => item.classList.remove('is-active'));
        swatch.classList.add('is-active');

        image.classList.add('is-changing');

        window.setTimeout(() => {
          image.src = newImage;
          image.srcset = '';
          image.alt = `The Phantom - ${newName}`;

          if (colorName) {
            colorName.textContent = newName;
          }

          image.classList.remove('is-changing');
        }, 180);
      });
    });
  });
});